var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeHoliday && _vm.animationComponent && _vm.shouldShowAnimation)?_c(_vm.animationComponent,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }